import { Box, Flex, Grid, GridItem, Image, Input, Text, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, FormControl, FormLabel, Button, Center, Spinner, Tooltip, IconButton, } from '@chakra-ui/react'
import MyDiv from './maritalStatus.style';
import { CustomButton, CustomToast } from '../../../../components';
import { useEffect, useState } from 'react';
import PlusIcon from "../../../../assets/images/Vector.svg";
import { IMarital } from './model';
import { useFetch } from '../../../../hooks/useFetch';
import CustomTables, { Column, ILazyParams } from '../../../../components/CustomTable/CustomTables';
import { EditIcon } from '@chakra-ui/icons';

const MaritalStatus = () => {
    const [maritals, setMaritals] = useState<IMarital[]>([]);
    const [DrawerOpen, setDrawerOpen] = useState(false);
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [currentMaritalStatus, setCurrentMaritalStatus] = useState({ id: 0, maritalStatus: '', });
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);
    const [dataLoading, setDataLoading] = useState(false);

    const [lazyParams, setLazyParams] = useState<ILazyParams>({ first: 0, rows: 0, sortField: undefined, sortOrder: undefined, multiSortMeta: [], filters: {}, globalFilter: '', });

    useEffect(() => {
        loadGroup();
    }, [lazyParams]);

    const loadGroup = async () => {
        setDataLoading(true);
        const params = new URLSearchParams();
        if (lazyParams.globalFilter) params.set('globalFilter', lazyParams.globalFilter);
        if (lazyParams.filters && Object.keys(lazyParams.filters).length) {
            params.set('filters', JSON.stringify(lazyParams.filters));
        }

        const response = await fetchApi<IMarital[]>(`Hrlense_MaritalStatus?${params.toString()}`, "GET");
        if (response) setMaritals(response);
        setDataLoading(false);
    };

    const handleAddNewMaritalStatus = () => {
        setIsEditMode(false);
        setCurrentMaritalStatus({ id: 0, maritalStatus: '', });
        setDrawerOpen(true);
    };

    const handleEditMaritalStatus = (maritalStatus: IMarital,) => {
        setIsEditMode(true);
        setSelectedId(maritalStatus.id);
        setCurrentMaritalStatus(maritalStatus);
        setDrawerOpen(true);
    };

    const handleInputChange = (e: any) => {
        const { name, value } = e.target;
        if (!/^[A-Za-z\s]*$/.test(value)) {
            return;
        }
        setCurrentMaritalStatus(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const handleSubmit = async () => {
        if (!currentMaritalStatus.maritalStatus.trim()) {
            addToast({ message: "Please enter Marital Status", status: "warning" });
            return;
        }
        if (isEditMode) {
            const response = await fetchApi(`Hrlense_MaritalStatus/${currentMaritalStatus.id}`, "PUT", { id: currentMaritalStatus.id, maritalStatus: currentMaritalStatus.maritalStatus, }, null, "Marital Status updated successfully");

            if (response) await loadGroup();
        } else {
            const response = await fetchApi<IMarital>("Hrlense_MaritalStatus", "POST", { maritalStatus: currentMaritalStatus.maritalStatus, }, null, "Marital Status added successfully");
            if (response) await loadGroup();
        }
        setDrawerOpen(false);
    };


    return (
        <MyDiv>
            <Box position="relative" minH="300px">
                <>
                    <Flex className="page_heading flex_header" >
                        <Text className="font-poppins text_semibold text_3xl">Marital Status </Text>
                        <Flex gap={2}>
                            <CustomButton title="Add New Marital Status" className=' btn font-poppins text_sm text_medium' rightIcon={<Image src={PlusIcon} className='logo' />} onClick={handleAddNewMaritalStatus} />
                        </Flex>
                    </Flex>
                    <Grid className='grid_container'>
                        <GridItem colSpan={12}>
                            <CustomTables<IMarital>
                                value={maritals} loading={dataLoading} emptyMessage="No marital statuses found." preferenceKey="maritalStatusTable"
                                showGlobalSearch={false} showToolbar={true} lazy lazyParams={lazyParams}
                                onLazyParamsChange={setLazyParams} showPagination={false} maxTableHeight={null}
                            >
                                <Column header="S. No" body={(_, index) => index + 1} />
                                <Column header="Marital Status" field="maritalStatus" sortable filterable filterType="text" />
                                <Column header="Actions" frozen="right" body={(row: any) => (
                                    <Tooltip label="Edit Marital Status" hasArrow>
                                        <IconButton aria-label="Edit" icon={<EditIcon />} size="sm" colorScheme="orange" variant="ghost" onClick={() => handleEditMaritalStatus(row)} />
                                    </Tooltip>
                                )}
                                />
                            </CustomTables>
                        </GridItem>
                    </Grid>

                    <Drawer isOpen={DrawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="sm">
                        <DrawerOverlay />
                        <DrawerContent>
                            <DrawerCloseButton />
                            <DrawerHeader borderBottomWidth="1px">{isEditMode ? 'Edit Marital Status' : 'Add New Marital Status'}</DrawerHeader>
                            <DrawerBody display="flex" flexDirection="column" justifyContent="space-between" height="100%">
                                <Box py={4}>
                                    <FormControl mb={4} isRequired>
                                        <FormLabel>Marital Status</FormLabel>
                                        <Input name="maritalStatus" value={currentMaritalStatus.maritalStatus} onChange={handleInputChange} placeholder="Enter marital status" />
                                    </FormControl>
                                </Box>
                                <Flex justify="flex-end" mt={4} gap={2}>
                                    <Button className="font-poppins text_sm text_medium" onClick={() => setDrawerOpen(false)} style={{ backgroundColor: '#D92F34', color: 'white' }}>Cancel</Button>
                                    <Button onClick={handleSubmit} className="font-poppins text_sm text_medium" style={{ backgroundColor: '#006838', color: 'white' }}>{isEditMode ? "Update Marital Status" : "Add Marital Status"}</Button>
                                </Flex>
                            </DrawerBody>
                        </DrawerContent>
                    </Drawer>
                </>
            </Box>
        </MyDiv>
    )
}

export default MaritalStatus;